{
  "dashboard": {
    "title": "Admin-Dashboard",
    "loading": "Laden...",
    "welcomeBack": "Willkommen zurück, {{name}}. Hier ist Ihre Plattformübersicht.",
    "platformOverview": "Plattformübersicht — Mandanten, Benutzer und Systemzustand auf einen Blick verwalten.",
    "refresh": "Aktualisieren",
    "aiSettings": "KI-Einstellungen",
    "servicesUnreachable": "Einige Dienste sind nicht erreichbar",
    "failedClients": "Mandantendaten konnten nicht geladen werden.",
    "failedUsers": "Benutzerdaten konnten nicht geladen werden.",
    "retry": "Erneut versuchen",
    "stats": {
      "clients": "Mandanten",
      "companies": "Unternehmen",
      "users": "Benutzer",
      "modules": "Module"
    },
    "quickActions": {
      "title": "Schnellaktionen",
      "manageClients": "Mandanten verwalten",
      "manageClientsDesc": "Mandantenkonten anzeigen und verwalten",
      "userManagement": "Benutzerverwaltung",
      "userManagementDesc": "Benutzer und ihre Rollen anzeigen",
      "aiSettings": "KI-Einstellungen",
      "aiSettingsDesc": "Globale KI-Konfiguration",
      "aiLogs": "KI-Protokolle",
      "aiLogsDesc": "KI-Betriebsprotokolle anzeigen"
    },
    "systemHealth": {
      "title": "Systemzustand",
      "allOperational": "Alles betriebsbereit",
      "issuesDetected": "Probleme erkannt",
      "authService": "Auth-Dienst",
      "userDirectory": "Benutzerverzeichnis",
      "tenantRegistry": "Mandantenregister",
      "moduleRegistry": "Modulregister",
      "operational": "Betriebsbereit",
      "apiUnreachable": "API nicht erreichbar",
      "cannotFetchUsers": "Benutzer können nicht abgerufen werden",
      "cannotFetchClients": "Mandanten können nicht abgerufen werden",
      "registered": "{{count}} registriert",
      "clients": "{{count}} Mandanten"
    },
    "recentClients": "Neueste Mandanten",
    "recentUsers": "Neueste Benutzer",
    "viewAll": "Alle anzeigen ({{count}})",
    "userRoleDistribution": "Benutzerrollenverteilung",
    "topClientsByCompanies": "Top-Mandanten nach Unternehmen",
    "registeredModules": "Registrierte Module",
    "noUserData": "Keine Benutzerdaten verfügbar",
    "noClientData": "Keine Mandantendaten verfügbar",
    "failedLoadClients": "Mandanten konnten nicht geladen werden",
    "noClientsYet": "Noch keine Mandanten",
    "failedLoadUsers": "Benutzer konnten nicht geladen werden",
    "noUsersYet": "Noch keine Benutzer",
    "company": "Unternehmen",
    "companies": "Unternehmen",
    "table": {
      "client": "Mandant",
      "companies": "Unternehmen",
      "created": "Erstellt",
      "user": "Benutzer",
      "role": "Rolle",
      "memberships": "Mitgliedschaften",
      "clientCount": "{{count}} Mandant(en)",
      "companyCount": "{{count}} Unternehmen",
      "tenantCount": "{{count}} Mandant",
      "tenantCount_plural": "{{count}} Mandanten"
    }
  },
  "ai": {
    "general": {
      "title": "KI-Allgemeine Einstellungen",
      "subtitle": "Globale KI-Einstellungen und Systemparameter konfigurieren.",
      "totalRequests": "Gesamtanfragen",
      "successRate": "Erfolgsrate",
      "avgResponseTime": "Durchschn. Antwortzeit",
      "activeModels": "Aktive Modelle",
      "tabs": {
        "api": "API-Konfiguration",
        "performance": "Leistung",
        "monitoring": "Überwachung",
        "security": "Sicherheit"
      },
      "fields": {
        "modelProvider": "Modellanbieter",
        "modelProviderRequired": "Bitte wählen Sie einen Modellanbieter",
        "modelProviderPlaceholder": "Modellanbieter auswählen",
        "apiKey": "API-Schlüssel",
        "apiKeyRequired": "Bitte geben Sie den API-Schlüssel ein",
        "apiKeyPlaceholder": "API-Schlüssel eingeben",
        "maxTokens": "Maximale Token",
        "maxTokensRequired": "Bitte geben Sie die maximalen Token ein",
        "maxTokensPlaceholder": "Maximale Token pro Anfrage",
        "temperature": "Temperatur",
        "temperatureRequired": "Bitte geben Sie die Temperatur ein",
        "temperaturePlaceholder": "Modelltemperatur (0-2)",
        "requestTimeout": "Anfrage-Timeout (Sekunden)",
        "timeoutRequired": "Bitte geben Sie das Timeout ein",
        "timeoutPlaceholder": "Anfrage-Timeout in Sekunden",
        "retryAttempts": "Wiederholungsversuche",
        "retryAttemptsRequired": "Bitte geben Sie die Wiederholungsversuche ein",
        "retryAttemptsPlaceholder": "Anzahl der Wiederholungsversuche",
        "enableCaching": "Antwort-Caching aktivieren",
        "cacheExpiry": "Cache-Ablauf (Sekunden)",
        "cacheExpiryRequired": "Bitte geben Sie den Cache-Ablauf ein",
        "cacheExpiryPlaceholder": "Cache-Ablauf in Sekunden",
        "enableRateLimit": "Ratenbegrenzung aktivieren",
        "rateLimit": "Ratenbegrenzung (Anfragen pro Minute)",
        "rateLimitRequired": "Bitte geben Sie die Ratenbegrenzung ein",
        "rateLimitPlaceholder": "Anfragen pro Minute",
        "enableLogging": "KI-Protokollierung aktivieren",
        "enableMonitoring": "Leistungsüberwachung aktivieren",
        "alertThreshold": "Alarm-Schwellenwert (%)",
        "alertThresholdRequired": "Bitte geben Sie den Alarm-Schwellenwert ein",
        "alertThresholdPlaceholder": "Alarm-Schwellenwert in Prozent",
        "logAllRequests": "Alle KI-Anfragen protokollieren",
        "enableEncryption": "Anfrageverschlüsselung aktivieren",
        "enableIpWhitelist": "IP-Whitelist aktivieren"
      },
      "security": {
        "title": "Sicherheitseinstellungen",
        "description": "Sicherheitsparameter für KI-Modellzugriff und Datenschutz konfigurieren."
      },
      "saveNotice": "Änderungen werden nach dem Speichern und Neustart des KI-Dienstes wirksam.",
      "reset": "Zurücksetzen",
      "saveSettings": "Einstellungen speichern",
      "settingsSaved": "Einstellungen erfolgreich gespeichert",
      "checkInput": "Bitte überprüfen Sie Ihre Eingabe",
      "settingsReset": "Einstellungen auf Standardwerte zurückgesetzt"
    },
    "logs": {
      "title": "Plattform-Logs",
      "subtitle": "Flow-Ausführungen aller Mandanten und das Änderungsprotokoll von Flows und Vorlagen."
    }
  },
  "tenants": {
    "title": "Mandantenverwaltung",
    "subtitle": "Mandantenkonten und zugehörige Unternehmen verwalten. Mandantenzugriff auf der Plattform erstellen, konfigurieren und überwachen.",
    "clients": "Mandanten",
    "addClient": "Mandant hinzufügen",
    "paginationTotal": "{{start}}-{{end}} von {{total}} Mandanten",
    "search": "Suche",
    "searchPlaceholder": "Nach Mandantenname suchen",
    "searchPending": "Suche läuft…",
    "searchResults": "{{count}} Mandanten für \"{{query}}\"",
    "noSearchResults": "Keine Mandanten für \"{{query}}\"",
    "clearFilters": "Filter zurücksetzen",
    "columns": {
      "client": "Mandant",
      "companies": "Unternehmen",
      "status": "Status",
      "createdAt": "Erstellt",
      "lastUpdated": "Zuletzt aktualisiert",
      "actions": "Aktionen"
    },
    "active": "Aktiv",
    "created": "Erstellt {{time}}",
    "manageClient": "Mandant verwalten",
    "manageClientTooltip": "Mandanteneinstellungen verwalten",
    "moduleManagement": "Modulverwaltung",
    "moduleManagementTooltip": "Module konfigurieren",
    "editClient": "Mandant bearbeiten",
    "addNewClient": "Mandant hinzufügen",
    "saveChanges": "Änderungen speichern",
    "createClient": "Mandant erstellen",
    "cancel": "Abbrechen",
    "form": {
      "clientName": "Mandantenname",
      "clientNameRequired": "Bitte geben Sie einen Mandantennamen ein.",
      "clientNameMin": "Der Mandantenname muss mindestens 2 Zeichen lang sein.",
      "clientNameDuplicate": "Ein Mandant mit diesem Namen existiert bereits.",
      "clientNameTooltip": "Der Anzeigename für diesen Mandanten",
      "clientNamePlaceholder": "z.B. Acme Corporation",
      "clientKey": "Mandantenschlüssel",
      "clientKeyRequired": "Bitte geben Sie einen Mandantenschlüssel ein.",
      "clientKeyPattern": "Der Schlüssel darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten.",
      "clientKeyDuplicate": "Ein Mandant mit diesem Schlüssel existiert bereits.",
      "clientKeyTooltip": "Eindeutiger Bezeichner für API-Aufrufe (Kleinbuchstaben, alphanumerisch, Bindestriche)",
      "clientKeyPlaceholder": "z.B. acme-corp"
    },
    "messages": {
      "updateNotImplemented": "Mandantenaktualisierung ist noch nicht implementiert",
      "createSuccess": "Mandant erfolgreich erstellt",
      "createError": "Mandant konnte nicht erstellt werden: {{error}}",
      "deleteNotImplemented": "Mandantenlöschung ist noch nicht implementiert"
    },
    "detail": {
      "backToClients": "Zurück zu Mandanten",
      "clientDetails": "Mandantendetails",
      "clientDetailsSubtitle": "Mandantendetails und Informationen",
      "errorLoading": "Fehler beim Laden des Mandanten: {{error}}",
      "clientNotFound": "Mandant nicht gefunden.",
      "viewLogs": "Protokolle anzeigen",
      "editClient": "Mandant bearbeiten",
      "deleteClient": "Mandant löschen",
      "clientInformation": "Mandanteninformationen",
      "generateRegistrationLink": "Registrierungslink generieren",
      "clientName": "Mandantenname",
      "clientKey": "Mandantenschlüssel",
      "clientId": "Mandanten-ID",
      "createdAt": "Erstellt am",
      "lastUpdated": "Zuletzt aktualisiert",
      "status": "Status",
      "active": "Aktiv",
      "companies": "Unternehmen",
      "addCompany": "Unternehmen hinzufügen",
      "totalCompanies": "Gesamtunternehmen",
      "edit": "Bearbeiten",
      "generateLink": "Link generieren",
      "noCompanies": "Keine Unternehmen mit diesem Mandanten verknüpft",
      "clientOwners": "Mandanteninhaber",
      "clientEmployees": "Mandantenmitarbeiter",
      "clientCustomers": "Mandantenkunden",
      "noOwnersFound": "Keine Inhaber gefunden",
      "noEmployeesFound": "Keine Mitarbeiter gefunden",
      "noCustomersFound": "Keine Kunden gefunden",
      "paginationOwners": "{{start}}-{{end}} von {{total}} Inhabern",
      "paginationEmployees": "{{start}}-{{end}} von {{total}} Mitarbeitern",
      "paginationCustomers": "{{start}}-{{end}} von {{total}} Kunden",
      "table": {
        "user": "Benutzer",
        "status": "Status",
        "role": "Rolle",
        "joined": "Beigetreten",
        "companies": "Unternehmen",
        "companyName": "Unternehmen",
        "domain": "Domain",
        "city": "Stadt",
        "country": "Land",
        "email": "E-Mail",
        "actions": "Aktionen"
      },
      "generateInviteLink": "Einladungslink erstellen",
      "addMember": {
        "title": "Mitglied hinzufügen",
        "description": "Fügen Sie einen Benutzer zum Mandanten {{name}} mit einer Mandantenrolle hinzu.",
        "button": "Mitglied hinzufügen",
        "selectUser": "Benutzer",
        "selectUserRequired": "Bitte wählen Sie einen Benutzer",
        "selectUserPlaceholder": "Benutzer wählen",
        "role": "Rolle",
        "roleOwner": "Inhaber",
        "roleEmployee": "Mitarbeiter",
        "add": "Mitglied hinzufügen",
        "cancel": "Abbrechen",
        "memberAdded": "Mitglied erfolgreich hinzugefügt",
        "addError": "Hinzufügen fehlgeschlagen: {{error}}",
        "noUsersAvailable": "Keine Benutzer zum Hinzufügen verfügbar"
      },
      "addToCompany": {
        "title": "Zu Unternehmen hinzufügen",
        "description": "Fügen Sie ein Mandantenmitglied zu {{company}} hinzu.",
        "descriptionAny": "Fügen Sie ein Mandantenmitglied zu einem Unternehmen hinzu.",
        "short": "Zu Unternehmen hinzufügen",
        "selectUser": "Mandantenmitglied",
        "selectUserRequired": "Bitte wählen Sie einen Benutzer",
        "selectUserPlaceholder": "Benutzer wählen",
        "selectCompany": "Unternehmen",
        "selectCompanyRequired": "Bitte wählen Sie ein Unternehmen",
        "selectCompanyPlaceholder": "Unternehmen wählen",
        "role": "Rolle",
        "roleOwner": "Inhaber",
        "roleEmployee": "Mitarbeiter",
        "add": "Zu Unternehmen hinzufügen",
        "cancel": "Abbrechen",
        "added": "Erfolgreich zum Unternehmen hinzugefügt",
        "error": "Hinzufügen fehlgeschlagen: {{error}}",
        "noMembers": "Keine Mandantenmitglieder zum Hinzufügen"
      },
      "removeFromCompany": {
        "confirmTitle": "Aus Unternehmen entfernen?",
        "confirmDesc": "Dieser Benutzer ist nicht mehr Mitglied dieses Unternehmens.",
        "ok": "Entfernen",
        "cancel": "Abbrechen"
      },
      "removeFromTenant": {
        "confirmTitle": "Aus Mandant entfernen?",
        "confirmDesc": "Dieser Benutzer verliert den Zugriff auf diesen Mandanten.",
        "button": "Entfernen",
        "ok": "Entfernen",
        "cancel": "Abbrechen"
      },
      "deleteCompany": {
        "confirmTitle": "Unternehmen löschen?",
        "confirmDesc": "Alle Mitglieder werden aus diesem Unternehmen entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
        "ok": "Löschen",
        "cancel": "Abbrechen",
        "tooltip": "Unternehmen löschen",
        "success": "Unternehmen gelöscht",
        "error": "Unternehmen konnte nicht gelöscht werden"
      },
      "activeStatus": "Aktiv",
      "inactiveStatus": "Inaktiv",
      "emailVerified": "E-Mail bestätigt",
      "emailUnverified": "E-Mail unbestätigt",
      "phoneVerified": "Telefon bestätigt",
      "phoneUnverified": "Telefon unbestätigt",
      "token": {
        "title": "Registrierungslink generieren",
        "generatingForClient": "Registrierungslink für Mandant: {{name}} wird generiert",
        "generatingForCompany": "Registrierungslink für Unternehmen: {{name}} wird generiert",
        "selectRoleDescription": "Wählen Sie eine Mandantenrolle für den Registrierungslink. Benutzer, die sich mit diesem Link registrieren, erhalten die ausgewählte Rolle.",
        "tenantRole": "Mandantenrolle",
        "tenantRoleRequired": "Bitte wählen Sie eine Mandantenrolle",
        "tenantRolePlaceholder": "Mandantenrolle auswählen",
        "tenantRoleTooltip": "Wählen Sie die Rolle, die Benutzern zugewiesen wird, die sich über diesen Link registrieren",
        "roleOwner": "Inhaber",
        "roleAdmin": "Administrator",
        "roleEmployee": "Mitarbeiter",
        "generateLink": "Link generieren",
        "close": "Schließen",
        "cancel": "Abbrechen",
        "successTitle": "Registrierungslink erfolgreich generiert",
        "successDescription": "Dieser Registrierungslink kann verwendet werden, um Benutzer mit der angegebenen Rolle zu diesem Mandanten einzuladen. Teilen Sie ihn sicher.",
        "linkDetails": "Link-Details",
        "tenantRoleLabel": "Mandantenrolle",
        "clientIdLabel": "Mandanten-ID",
        "companyIdLabel": "Unternehmens-ID",
        "expiresAt": "Läuft ab am",
        "registrationUrl": "Registrierungs-URL",
        "registrationLink": "Registrierungslink:",
        "copyRegistrationLink": "Registrierungslink kopieren",
        "securityNotice": "Sicherheitshinweis",
        "securityDescription": "Diese Registrierungs-URL wird nur einmal angezeigt. Stellen Sie sicher, dass Sie sie kopieren, bevor Sie diesen Dialog schließen. Jeder mit dieser URL kann sich registrieren und dem Mandanten mit der angegebenen Rolle beitreten.",
        "tokenSuccess": "Token erfolgreich ausgestellt",
        "tokenError": "Token konnte nicht ausgestellt werden: {{error}}",
        "copySuccess": "Registrierungs-URL in die Zwischenablage kopiert!"
      },
      "messages": {
        "editNotImplemented": "Mandantenbearbeitung ist noch nicht implementiert",
        "deleteNotImplemented": "Mandantenlöschung ist noch nicht implementiert",
        "companyCreated": "Unternehmen erfolgreich erstellt",
        "companyCreateError": "Unternehmen konnte nicht erstellt werden: {{error}}",
        "companyUpdated": "Unternehmen erfolgreich aktualisiert",
        "companyUpdateError": "Unternehmen konnte nicht aktualisiert werden: {{error}}"
      },
      "addCustomer": {
        "title": "Kunde hinzufügen",
        "description": "Einem bestehenden Benutzer Kundenzugang zu Mandant {{name}} geben.",
        "add": "Kunde hinzufügen",
        "memberAdded": "Kunde hinzugefügt",
        "addError": "Kunde konnte nicht hinzugefügt werden: {{error}}"
      },
      "customers": {
        "title": "Kunden",
        "search": "Name, E-Mail oder Telefon suchen",
        "invite": "Kunde einladen",
        "add": "Kunde hinzufügen",
        "removed": "Kunde aus dem Mandanten entfernt",
        "removeError": "Kunde konnte nicht entfernt werden"
      },
      "eventTriggers": {
        "title": "Event-Trigger",
        "subtitle": "Ordnen Sie Domain-Events den Flows dieses Mandanten zu.",
        "eventType": "Event-Typ",
        "flow": "Flow",
        "triggerNode": "Trigger-Knoten",
        "active": "Aktiv",
        "addMapping": "Zuordnung hinzufügen",
        "addMappingTooltip": "Ein Domain-Event einem Flow-Trigger zuordnen",
        "add": "Zuordnung erstellen",
        "cancel": "Abbrechen",
        "delete": "Löschen",
        "allEvents": "Alle Events",
        "allFlows": "Alle Flows",
        "allNodes": "Alle Knoten",
        "clearFilters": "Filter zurücksetzen",
        "showingCount": "{{count}} von {{total}} Zuordnungen",
        "empty": "Noch keine Event-Zuordnungen",
        "emptyHint": "Events wie ein neu erstellter Termin oder eine Benutzerregistrierung können Automatisierungen starten.",
        "deleteTooltip": "Diese Zuordnung löschen",
        "deleteConfirm": "Diese Zuordnung löschen?",
        "deleteConfirmDescription": "Die Event-Zuordnung wird entfernt. Sie können sie später erneut hinzufügen.",
        "selectEvent": "Event auswählen",
        "selectFlow": "Flow auswählen",
        "selectTriggerNode": "Trigger-Knoten auswählen",
        "selectFlowFirst": "Zuerst einen Flow auswählen",
        "addSuccess": "Event-Zuordnung erstellt",
        "addError": "Zuordnung konnte nicht erstellt werden",
        "deleteSuccess": "Zuordnung gelöscht",
        "deleteError": "Zuordnung konnte nicht gelöscht werden",
        "enabledSuccess": "Zuordnung aktiviert",
        "disabledSuccess": "Zuordnung deaktiviert",
        "updateError": "Zuordnung konnte nicht aktualisiert werden",
        "eventDescriptions": {
          "onAppointmentConfirmed": "Wird ausgelöst, wenn ein Termin vom Kunden oder System bestätigt wird.",
          "onAppointmentCreated": "Wird ausgelöst, wenn ein neuer Termin erstellt wird.",
          "onAppointmentRescheduled": "Wird ausgelöst, wenn ein bestehender Termin auf eine neue Zeit verschoben wird.",
          "onAppointmentRescheduleRequested": "Wird ausgelöst, wenn ein Kunde eine Verschiebungsanfrage stellt und der Termin zur Prüfung ansteht.",
          "onAppointmentRescheduleRequestRejected": "Wird ausgelöst, wenn eine Verschiebungsanfrage abgelehnt und der vorherige Status des Termins wiederhergestellt wird.",
          "onAppointmentCancelled": "Wird ausgelöst, wenn ein Termin storniert wird.",
          "onAppointmentNoShow": "Wird ausgelöst, wenn ein Termin als nicht wahrgenommen markiert wird.",
          "onAppointmentCompleted": "Wird ausgelöst, wenn ein Termin als abgeschlossen markiert wird.",
          "onUserRegistered": "Wird ausgelöst, wenn ein neuer Benutzer die Registrierung abschließt.",
          "onThreadCreated": "Wird ausgelöst, wenn ein neuer Chat- oder Support-Thread erstellt wird.",
          "onThreadArchived": "Wird ausgelöst, wenn ein Chat- oder Support-Thread archiviert wird.",
          "onConversationCompleted": "Wird ausgelöst, wenn ein Anruf, Chat oder eine E-Mail-Konversation abgeschlossen ist, mit Zusammenfassung und Prüfmarkierungen.",
          "onCallFinished": "Wird ausgelöst, wenn ein Telefonanruf endet.",
          "onLeadCreated": "Wird ausgelöst, wenn aus einer anonymen Interaktion ein Lead wird.",
          "onLeadVerified": "Wird ausgelöst, wenn ein Lead mindestens eine Kontaktangabe verifiziert.",
          "onLeadConverted": "Wird ausgelöst, wenn ein Lead in einen Kunden oder eine Verkaufschance umgewandelt wird.",
          "onCustomerCreated": "Wird ausgelöst, wenn ein neuer Kundendatensatz erstellt wird."
        }
      },
      "backToTenant": "Zurück zum Mandanten"
    },
    "logs": {
      "title": "Mandanten-Logs",
      "clientNotFound": "Mandant nicht gefunden.",
      "backToTenant": "Zurück zu {{name}}",
      "clientLogsFor": "Logs – {{name}}",
      "subtitle": "Flow-Ausführungen dieses Mandanten und Änderungen an seinen Flows."
    },
    "modules": {
      "title": "Modulverwaltung",
      "backToClient": "Zurück zum Mandanten",
      "managingFor": "Module verwalten für: {{name}}",
      "loadingModules": "Module werden geladen...",
      "noModulesMatch": "Keine Module entsprechen Ihren aktuellen Filtern",
      "noModulesAvailable": "Keine Module verfügbar",
      "clearAllFilters": "Alle Filter löschen"
    },
    "empty": "Noch keine Mandanten"
  },
  "users": {
    "title": "Benutzerverwaltung",
    "subtitle": "Benutzer und ihre Mandantenmitgliedschaften überprüfen.",
    "filters": "Filter",
    "client": "Mandant",
    "company": "Unternehmen",
    "role": "Rolle",
    "allClients": "Alle Mandanten",
    "allCompanies": "Alle Unternehmen",
    "allRoles": "Alle Rollen",
    "clearFilters": "Filter löschen",
    "search": "Suche",
    "searchPlaceholder": "Name oder E-Mail",
    "searchPending": "Suche läuft…",
    "searchResults": "{{count}} Benutzer für \"{{query}}\"",
    "noSearchResults": "Keine Benutzer für \"{{query}}\"",
    "paginationTotal": "{{start}}-{{end}} von {{total}} Benutzern",
    "columns": {
      "user": "Benutzer",
      "role": "Rolle",
      "tenants": "Mandanten",
      "companies": "Unternehmen",
      "status": "Status",
      "actions": "Aktionen"
    },
    "joined": "Beigetreten: {{date}}",
    "none": "Keine",
    "more": "+{{count}} weitere",
    "emailVerified": "E-Mail bestätigt",
    "emailUnverified": "E-Mail unbestätigt",
    "phoneVerified": "Telefon bestätigt",
    "phoneUnverified": "Telefon unbestätigt",
    "view": "Anzeigen",
    "verification": {
      "resendEmail": "Bestätigungs-E-Mail erneut senden",
      "markVerified": "Als bestätigt markieren",
      "resendSuccess": "Bestätigungs-E-Mail wurde gesendet.",
      "resendError": "Bestätigungs-E-Mail konnte nicht gesendet werden.",
      "verifySuccess": "E-Mail als bestätigt markiert.",
      "verifyError": "E-Mail konnte nicht bestätigt werden.",
      "verifyConfirmTitle": "E-Mail als bestätigt markieren?",
      "verifyConfirmDescription": "{{name}} kann sich dann ohne Bestätigungslink anmelden.",
      "verifyConfirmOk": "Als bestätigt markieren",
      "verifyConfirmCancel": "Abbrechen",
      "unverifiedAlertTitle": "E-Mail nicht bestätigt",
      "unverifiedAlertDescription": "{{email}} kann sich erst anmelden, wenn die E-Mail bestätigt ist. Senden Sie die Bestätigungs-E-Mail erneut oder markieren Sie sie manuell als bestätigt."
    },
    "create": {
      "button": "Benutzer hinzufügen",
      "title": "Benutzer hinzufügen",
      "submit": "Benutzer erstellen",
      "cancel": "Abbrechen",
      "email": "E-Mail",
      "emailRequired": "E-Mail ist erforderlich",
      "emailInvalid": "Geben Sie eine gültige E-Mail-Adresse ein",
      "password": "Passwort",
      "passwordRequired": "Passwort ist erforderlich",
      "passwordMin": "Passwort muss mindestens 8 Zeichen lang sein",
      "passwordHint": "Muss Groß- und Kleinbuchstaben, Zahl und Sonderzeichen (@$!%*?&) enthalten",
      "name": "Name",
      "nameRequired": "Name ist erforderlich",
      "phone": "Telefon (optional)",
      "globalRole": "Globale Rolle",
      "tenantSectionHint": "Optional: Benutzer einem Mandanten und Unternehmen zuweisen. Das Konto wird mit bereits bestätigter E-Mail erstellt.",
      "client": "Mandant",
      "clientPlaceholder": "Mandant auswählen (optional)",
      "company": "Unternehmen",
      "companyPlaceholder": "Unternehmen auswählen (optional)",
      "tenantRole": "Mandantenrolle",
      "tenantRoleEmployee": "Mitarbeiter",
      "tenantRoleOwner": "Inhaber",
      "tenantRoleCustomer": "Kunde",
      "success": "Benutzer erfolgreich erstellt.",
      "error": "Benutzer konnte nicht erstellt werden: {{error}}"
    },
    "detail": {
      "title": "Benutzerdetails",
      "backToUsers": "Zurück zu Benutzern",
      "errorLoading": "Fehler beim Laden des Benutzers: {{error}}",
      "subtitle": "Benutzerprofil und Mandantenmitgliedschaften.",
      "profile": "Profil",
      "globalRole": "Globale Rolle",
      "verificationStatus": "Verifizierungsstatus",
      "userId": "Benutzer-ID",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am",
      "loading": "Laden...",
      "userNotFound": "Benutzer nicht gefunden.",
      "tenantMemberships": "Mandantenmitgliedschaften",
      "companyMemberships": "Unternehmensmitgliedschaften",
      "table": {
        "client": "Mandant",
        "role": "Rolle",
        "status": "Status",
        "created": "Erstellt",
        "company": "Unternehmen"
      },
      "owner": "Inhaber",
      "member": "Mitglied",
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "tenantAccess": {
        "title": "Mandantenzugriff",
        "assign": "Mandant zuweisen",
        "emptyTitle": "Dieser Benutzer hat noch keinen Mandantenzugriff",
        "emptyDescription": "Weisen Sie einen Mandanten zu, um Zugriff als Inhaber, Mitarbeiter oder Kunde zu geben.",
        "removeConfirmTitle": "Aus {{tenant}} entfernen?",
        "removeConfirmDesc": "Der Benutzer verliert den Zugriff auf diesen Mandanten und alle seine Firmen.",
        "removedFromTenant": "Aus {{tenant}} entfernt",
        "missingTenantLink": "Firmenzugriff ohne Mandantenmitgliedschaft.",
        "addTenantLink": "Als Mitarbeiter hinzufügen",
        "tenantLinkAdded": "Als Mitarbeiter zum Mandanten hinzugefügt",
        "companyRoleUpdated": "Firmenrolle aktualisiert",
        "removedFromCompany": "Aus der Firma entfernt",
        "noCompanies": "Keiner Firma dieses Mandanten zugewiesen.",
        "customerNoCompanies": "Kunden haben mandantenweiten Zugriff und werden keinen Firmen zugewiesen.",
        "actionError": "Die Änderung konnte nicht gespeichert werden",
        "assignTitle": "Mandant zuweisen",
        "assignSubmit": "Zuweisen",
        "assignDescription": "{{name}} Zugriff auf einen Mandanten und optional einige seiner Firmen geben.",
        "tenant": "Mandant",
        "tenantRequired": "Bitte einen Mandanten auswählen",
        "tenantRole": "Mandantenrolle",
        "companies": "Firmen",
        "companiesHint": "Optional. Inhaber und Mitarbeiter können auch später zu Firmen hinzugefügt werden.",
        "companyRole": "Firmenrolle",
        "assigned": "{{tenant}} zugewiesen",
        "assignPartial": "{{tenant}} zugewiesen, aber das Hinzufügen dieser Firmen ist fehlgeschlagen: {{companies}}",
        "assignError": "Mandant konnte nicht zugewiesen werden",
        "staffTitle": "Admins und Entwickler werden keinen Mandanten zugewiesen",
        "staffDescription": "Ihre globale Rolle gibt ihnen bereits Zugriff auf alle Mandanten.",
        "staffKeptNote": "Aus der Zeit vor der Ernennung zum Admin/Entwickler übernommen. Sie haben derzeit keine Wirkung (die globale Rolle gibt bereits Zugriff auf alle Mandanten) und gelten wieder, wenn der Benutzer herabgestuft wird."
      }
    },
    "empty": "Keine Benutzer gefunden",
    "roleOptions": {
      "ADMIN": "Administrator",
      "DEVELOPER": "Entwickler",
      "USER": "Benutzer",
      "CUSTOMER": "Kunde"
    },
    "searchByNameOrEmail": "Nach Name oder E-Mail suchen"
  },
  "roles": {
    "admin": "Administrator",
    "user": "Benutzer",
    "customer": "Kunde"
  },
  "roleEditor": {
    "cannotChangeOwnRole": "Sie können Ihre eigene Rolle nicht ändern",
    "editTooltip": "Klicken, um Benutzerrolle zu bearbeiten",
    "changeTitle": "Benutzerrolle ändern",
    "saveChanges": "Änderungen speichern",
    "cancel": "Abbrechen",
    "editingFor": "Rolle bearbeiten für:",
    "selectNewRole": "Neue Rolle auswählen:",
    "current": "Aktuell",
    "confirmTitle": "Rollenänderung bestätigen",
    "confirmDescription": "Sie sind dabei, die Benutzerrolle auf <strong>{{role}}</strong> zu ändern.",
    "selectRole": "Bitte wählen Sie eine Rolle",
    "noChanges": "Keine Änderungen vorgenommen",
    "updateSuccess": "Benutzerrolle erfolgreich aktualisiert",
    "updateError": "Benutzerrolle konnte nicht aktualisiert werden"
  },
  "modules": {
    "searchPlaceholder": "Module nach Name, ID, Beschreibung, Autor oder Kategorie suchen...",
    "all": "Alle ({{count}})",
    "enabled": "Aktiviert ({{count}})",
    "disabled": "Deaktiviert ({{count}})",
    "filterByCategory": "Nach Kategorie filtern:",
    "allCategories": "Alle Kategorien",
    "columns": {
      "module": "Modul",
      "id": "ID",
      "requiredRoles": "Erforderliche Rollen",
      "configuration": "Konfiguration",
      "actions": "Aktionen"
    },
    "enabledStatus": "Aktiviert",
    "disabledStatus": "Deaktiviert",
    "none": "Keine",
    "configRequired": "Konfiguration zum Aktivieren erforderlich",
    "required": "Erforderlich",
    "notConfigured": "Nicht konfiguriert",
    "incomplete": "Unvollständig",
    "missing": "Fehlend: {{fields}}",
    "complete": "Vollständig",
    "fullyConfigured": "Vollständig konfiguriert",
    "default": "Standard",
    "configureModule": "Modul konfigurieren",
    "configureToEnable": "Zum Aktivieren konfigurieren",
    "totalModules": "Gesamt {{count}} Module",
    "enableModal": {
      "title": "Modul aktivieren: {{name}}",
      "okText": "Modul aktivieren",
      "cancel": "Abbrechen",
      "configRequired": "Konfiguration erforderlich",
      "configRequiredDesc": "Bitte füllen Sie alle erforderlichen Felder aus, um dieses Modul zu aktivieren.",
      "noConfigRequired": "Keine Konfiguration erforderlich",
      "noConfigRequiredDesc": "Dieses Modul kann ohne zusätzliche Konfiguration aktiviert werden."
    },
    "configModal": {
      "title": "Modul konfigurieren: {{name}}",
      "okText": "Konfiguration speichern",
      "cancel": "Abbrechen",
      "moduleId": "Modul-ID",
      "version": "Version",
      "author": "Autor",
      "description": "Beschreibung",
      "noDescription": "Keine Beschreibung",
      "na": "N/V",
      "noSchema": "Kein Konfigurationsschema",
      "noSchemaDesc": "Dieses Modul hat kein definiertes Konfigurationsschema.",
      "saveError": "Konfiguration konnte nicht gespeichert werden"
    }
  },
  "conversationOverview": {
    "title": "Mandantenübergreifende Gesprächsübersicht",
    "description": "Gesprächsaktivität über alle Mandanten, um Probleme früh zu erkennen.",
    "level1Title": "Zusammenfassung pro Mandant",
    "level2Title": "Detaillierte Gespräche",
    "yes": "Ja",
    "no": "Nein",
    "transferred": "An einen Mitarbeiter weitergeleitet",
    "loadError": "Gesprächsübersicht konnte nicht geladen werden.",
    "emptyTenants": "Keine Mandanten gefunden.",
    "emptyConversations": "Keine Gespräche für die gewählten Filter.",
    "paginationTotal": "{{start}}-{{end}} von {{total}} Gesprächen",
    "periods": {
      "today": "Heute",
      "7d": "Letzte 7 Tage",
      "30d": "Letzte 30 Tage",
      "custom": "Benutzerdefiniert"
    },
    "filters": {
      "tenant": "Mandant",
      "channel": "Kanal",
      "flag": "Flag",
      "humanHandoff": "Human Handoff",
      "technicalIssue": "Technisches Problem",
      "clearAll": "Filter löschen"
    },
    "columns": {
      "tenant": "Mandant",
      "total": "Gespräche gesamt",
      "technicalIssue": "Technisches Problem",
      "humanHandoff": "Human Handoff",
      "flaggedRed": "Rot markiert",
      "channel": "Kanal",
      "startedAt": "Datum und Uhrzeit",
      "duration": "Dauer",
      "customerHelped": "Kunde geholfen",
      "delay": "Verzögerung",
      "callbackRequested": "Rückruf angefordert",
      "flag": "Flag",
      "summary": "Zusammenfassung",
      "actions": "Aktionen"
    },
    "channel": {
      "call": "Anruf",
      "chat": "Chat",
      "email": "E-Mail"
    },
    "flag": {
      "green": "Grün",
      "red": "Rot"
    },
    "duration": {
      "seconds": "{{seconds}}s",
      "minutesSeconds": "{{minutes}}m {{seconds}}s",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "veryShort": "sehr kurz",
      "veryLong": "sehr lang"
    },
    "details": "Details",
    "detail": {
      "back": "Zurück zur Übersicht",
      "notFound": "Gespräch nicht gefunden",
      "notFoundDescription": "Dieser Thread fehlt oder ist nicht mehr verfügbar.",
      "openFlow": "Flow öffnen",
      "copyThreadId": "Thread-ID kopieren",
      "copyCallId": "Anruf-ID kopieren",
      "copied": "Kopiert",
      "completion": "Abschluss",
      "identifiers": "Kennungen",
      "voice": "Anruf",
      "summary": "Zusammenfassung",
      "started": "Gestartet",
      "ended": "Beendet",
      "customerHelped": "Kunde geholfen",
      "technicalIssues": "Gründe für das technische Problem",
      "contact": "Kontakt",
      "threadId": "Thread-ID",
      "client": "Mandant",
      "companyId": "Unternehmens-ID",
      "flowId": "Flow-ID",
      "callId": "Anruf-ID",
      "sessionId": "Sitzungs-ID",
      "userId": "Benutzer-ID",
      "status": "Status",
      "fromNumber": "Von",
      "toNumber": "An",
      "callStatus": "Anrufstatus",
      "endReason": "Endgrund",
      "endCode": "Endcode",
      "provider": "Anbieter",
      "engine": "Engine",
      "transport": "Transport",
      "noFlow": "Kein Flow zugewiesen",
      "internalContext": "Interner Kontext",
      "contextSummary": "Kontextzusammenfassung",
      "voiceContext": "Voice-Abschlusskontext",
      "redFlagAlert": "Dieses Gespräch ist rot markiert.",
      "technicalIssueAlert": "Für dieses Gespräch wurde ein technisches Problem erfasst.",
      "turn": "Durchgang {{index}}",
      "openExecution": "Ausführung öffnen",
      "noExecution": "Keine Flow-Ausführung",
      "copyCorrelationId": "Korrelations-ID kopieren",
      "truncatedMessages": "Das Transkript ist möglicherweise unvollständig. Es wurden nur die letzten 1000 Nachrichten geladen.",
      "truncatedExecutions": "Einige Flow-Ausführungen wurden nicht geladen. Zugehörige Durchgänge zeigen dann keine Ausführung.",
      "emailSummaryOnly": "Diese E-Mail-Unterhaltung wird mit ihrer Abschlusszusammenfassung angezeigt. Der Nachrichtentext ist auf dieser Seite nicht verfügbar.",
      "noData": "—",
      "active": "Aktiv",
      "archived": "Archiviert"
    }
  },
  "tenantPickers": {
    "tenantPlaceholder": "Mandant auswählen",
    "noTenants": "Keine Mandanten verfügbar",
    "companyPlaceholder": "Firmen auswählen",
    "noCompanies": "Dieser Mandant hat keine Firmen"
  },
  "logs": {
    "view": "Ansehen",
    "pagination": "{{start}}–{{end}} von {{total}}",
    "emptyHint": "Wählen Sie einen längeren Zeitraum oder setzen Sie die Filter zurück.",
    "refresh": "Aktualisieren",
    "export": "CSV exportieren",
    "lastUpdated": "Aktualisiert {{time}}",
    "status": {
      "STARTED": "Läuft",
      "COMPLETED": "Abgeschlossen",
      "FAILED": "Fehlgeschlagen"
    },
    "tabs": {
      "executions": "Flow-Ausführungen",
      "audit": "Änderungsprotokoll"
    },
    "kpi": {
      "total": "Ausführungen",
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen",
      "running": "Laufend"
    },
    "filters": {
      "allTenants": "Alle Mandanten",
      "allStatuses": "Alle Status",
      "searchAudit": "Benutzer, Aktion oder Objekt suchen",
      "clear": "Filter zurücksetzen",
      "tenantLevel": "Mandantenebene",
      "company": "Firma: {{name}}"
    },
    "executions": {
      "columns": {
        "time": "Zeit",
        "status": "Status",
        "tenant": "Mandant",
        "flow": "Flow",
        "duration": "Dauer",
        "error": "Fehler",
        "correlationId": "Korrelations-ID"
      },
      "empty": "Keine Flow-Ausführungen in diesem Zeitraum",
      "failedInNode": "Fehlgeschlagen in Knoten {{node}}"
    },
    "audit": {
      "columns": {
        "time": "Zeit",
        "user": "Benutzer",
        "action": "Aktion",
        "entity": "Objekt-ID"
      },
      "empty": "Keine Protokolleinträge in diesem Zeitraum",
      "emptyHint": "Erfasst werden nur das Erstellen und Ändern von Flows und Vorlagen.",
      "actions": {
        "FLOW_CREATED": "Flow erstellt",
        "FLOW_UPDATED": "Flow geändert",
        "TEMPLATE_CREATED": "Vorlage erstellt",
        "TEMPLATE_UPDATED": "Vorlage geändert"
      }
    },
    "drawer": {
      "title": "Flow-Ausführung",
      "openInBackstage": "In Backstage öffnen",
      "startedAt": "Gestartet",
      "duration": "Dauer",
      "tenant": "Mandant",
      "template": "Vorlage",
      "triggeredBy": "Ausgelöst durch",
      "executionId": "Ausführungs-ID",
      "correlationId": "Korrelations-ID",
      "userId": "Benutzer-ID",
      "conversation": "Unterhaltung",
      "openConversation": "Unterhaltung öffnen",
      "steps": "Schritte",
      "noSteps": "Für diese Ausführung wurden keine Schritte erfasst",
      "triggerData": "Auslöserdaten",
      "timings": "Zeitmessungen",
      "failedNode": "Fehlerknoten"
    }
  }
}
